// extracted by mini-css-extract-plugin
export default {"wraper":"Card_wraper__GRuW+","content":"Card_content__7Omx-","center":"Card_center__nio0R","group":"Card_group__G9Yu+"};